import { render, staticRenderFns } from "./CorporatePoliciesCategories.vue?vue&type=template&id=3684dfe8&"
import script from "./CorporatePoliciesCategories.vue?vue&type=script&lang=js&"
export * from "./CorporatePoliciesCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports